var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoard = function SvgBoard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22217 12.4727H12.7777",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22217 9.69434H12.7777",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7779 2.75H16.2501C16.4343 2.75 16.6109 2.82316 16.7412 2.9534C16.8714 3.08363 16.9446 3.26027 16.9446 3.44444V18.0278C16.9446 18.212 16.8714 18.3886 16.7412 18.5188C16.6109 18.6491 16.4343 18.7222 16.2501 18.7222H3.75011C3.56593 18.7222 3.3893 18.6491 3.25906 18.5188C3.12883 18.3886 3.05566 18.212 3.05566 18.0278V3.44444C3.05566 3.26027 3.12883 3.08363 3.25906 2.9534C3.3893 2.82316 3.56593 2.75 3.75011 2.75H7.22233",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52783 5.52799V4.83355C6.52783 3.91266 6.89365 3.02949 7.54482 2.37832C8.19599 1.72715 9.07916 1.36133 10.0001 1.36133C10.9209 1.36133 11.8041 1.72715 12.4553 2.37832C13.1065 3.02949 13.4723 3.91266 13.4723 4.83355V5.52799H6.52783Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBoard;